<template>
  <vue-element-loading
    class="loader"
    data-cy="loader"
    :active="!!isLoading"
    :spinner="spinnerType"
    :duration="duration"
    :size="size"
    :color="color"
    :is-full-screen="fullScreen"
    :background-color="backgroundColor"
  />
</template>

<script setup lang="ts">
import { LOADER_DURATION, LOADER_SPINNER_TYPE } from "@/helpers/constants";

import VueElementLoading from "@/components/ui/vue-element-loading/vue-element-loading.vue";

type LoaderProps = {
  isLoading: boolean | number;
  size?: string;
  spinnerType?: "spinner" | "line-scale";
  duration?: string;
  color?: string;
  fullScreen?: boolean;
  zIndex?: number;
  backgroundColor?: string;
};

const {
  isLoading,
  size = "40",
  spinnerType = LOADER_SPINNER_TYPE,
  duration = LOADER_DURATION,
  color = "#00FF72",
  fullScreen = false,
  zIndex = 100,
  backgroundColor = "white",
} = defineProps<LoaderProps>();
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.loader {
  z-index: v-bind(zIndex) !important;
}
</style>
